import { COMMON } from "../../../util/localizations"
import { dataSize } from "../../../util/magnitudes"
import { MAX_FILE_SIZE } from "./config"

const size = dataSize( MAX_FILE_SIZE );

const TRANSLATIONS = {
    en: {
        noPornTitle: 'Consider the Littles',
        noPornBody: `${ COMMON.appName } can not, in good conscience, allow for content that is harmful to children to be published to the blockchain. In the interest of transparency, any image you select here will be scanned for nudity and sexual content.`,
        naughtyImage: 'Inappropriate content was detected. Either censor the image or use a different one.',
        tooBig: `File, "{0}" exceeds the maximum allowable size of ${ size }.`
    }
}

export default TRANSLATIONS